import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = ({ currentLanguage }) => {
  const content = {
    fr: {
      title: 'Certifications et conformité',
      badges: [
        {
          icon: 'Shield',
          title: 'Conforme RGPD',
          description: 'Protection des données certifiée'
        },
        {
          icon: 'Award',
          title: 'Agréé Ministère',
          description: 'Licence officielle Maroc'
        },
        {
          icon: 'Star',
          title: 'Nusuk Intégré',
          description: 'Plateforme officielle Arabie Saoudite'
        },
        {
          icon: 'CheckCircle',
          title: 'Conformité islamique',
          description: 'Respect des principes religieux'
        }
      ]
    },
    ar: {
      title: 'الشهادات والامتثال',
      badges: [
        {
          icon: 'Shield',
          title: 'متوافق مع RGPD',
          description: 'حماية البيانات المعتمدة'
        },
        {
          icon: 'Award',
          title: 'معتمد من الوزارة',
          description: 'ترخيص رسمي المغرب'
        },
        {
          icon: 'Star',
          title: 'متكامل مع نسك',
          description: 'المنصة الرسمية السعودية'
        },
        {
          icon: 'CheckCircle',
          title: 'الامتثال الإسلامي',
          description: 'احترام المبادئ الدينية'
        }
      ]
    }
  };

  const text = content?.[currentLanguage];

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 lg:p-8">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6 text-center">
        {text?.title}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {text?.badges?.map((badge, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-4 rounded-lg bg-background hover:bg-muted transition-smooth"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <Icon name={badge?.icon} size={24} className="text-primary" />
            </div>
            <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">
              {badge?.title}
            </h4>
            <p className="caption text-muted-foreground">
              {badge?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBadges;